import { createTheme } from "@mui/material";
import { grey } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    primary: {
      light: "#e8f6fd",
      main: "#109ee6",
      dark: "#3094db",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#00ccbe",
      contrastText: "#2d1e5f"
    },
    tertiary: {
      light: "#574b7f",
      main: "#2d1e5f",
      dark: "#1f1542",
      contrastText: "#ffffff"
    },
    error: {
      light: "#fdeded",
      main: "#ff0000",
      dark: "#5f2120"
    },
    gray: {
      light: grey[400],
      main: grey[600],
      dark: grey[800]
    },
    warning: {
      main: "#ffc800"
    }
  },
  typography: {
    fontFamily: "'Gotham', sans-serif"
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 55,
          minWidth: 120,
          textTransform: "none"
        }
      },
      defaultProps: {
        disableRipple: true,
        iconPosition: "start"
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none"
        }
      }
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          fontSize: 9,
          height: 15,
          minWidth: 15
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          marginTop: 15
        },
        asterisk: {
          color: "#ff0000"
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          "&:last-child": {
            paddingBottom: 16
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: "white"
        }
      },
      defaultProps: {
        autoComplete: "off"
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0
        }
      }
    }
  }
});

export default theme;
